module.exports = __webpack_public_path__ + "static/media/3.question.70d75247.mp4";